import type { ReactNode } from 'react';
import { TanStackTable } from '../../../../components/tanstack-table/table';
import type { EditOrderViewModel } from '../hooks/use-edit-order-view';

type EditOrderTableProperties = {
  view: EditOrderViewModel;
  /** Mode-specific summary row pinned under the header. */
  headerContent: ReactNode;
};

export function EditOrderTable({ view, headerContent }: EditOrderTableProperties) {
  return (
    <TanStackTable
      data={view.filteredOrderItems}
      columns={view.columns}
      columnVisibility={view.columnVisibility}
      columnOrder={view.columnOrder}
      rowHeight={25}
      sorting={view.sorting}
      rowSelection={view.rowSelection}
      onRowSelectionChange={view.onRowSelectionChange}
      onRowClick={view.handleRowClick}
      getRowId={(item) => item.product.id}
      headerContent={headerContent}
      scrollRef={view.tableScrollRef}
      onScroll={view.onTableScroll}
      getRowClassName={view.getRowClassName}
      getRowStripe={view.getRowStripe}
      onTableReady={view.onTableReady}
    />
  );
}
